// extracted by mini-css-extract-plugin
module.exports = {"container":"_2YcYzx","price":"GzPWA2","content":"_2blWqm","loading":"_1h4SEa","priceDiff":"_3bMaS9","priceDiff__row":"Wop08y","priceDiff__result":"_1X-cEL Wop08y"};